import React from "react";
import { motion } from "framer-motion";
import { FaBullseye, FaEye } from "react-icons/fa";
import SectionHeading from "../SectionHeading";

const cards = [
  {
    title: "Mission",
    icon: FaBullseye,
    paragraphs: [
      "To provide innovative, cost-effective, and sustainable construction solutions, fostering long-term client relationships built on trust and quality. We strive to create value through efficient project management, ensuring timely delivery while upholding the highest standards of safety and craftsmanship in every project.",
      "Our mission is to continuously improve our processes and services to meet and exceed client expectations, while also contributing positively to the communities we serve.",
    ],
  },
  {
    title: "Vision",
    icon: FaEye,
    paragraphs: [
      "To lead the construction industry by driving innovation, sustainability, and excellence in every project.",
      "Our vision is to be recognized as a benchmark for quality and integrity, setting new standards in the construction industry and inspiring others to follow our lead.",
    ],
  },
];

function MissionVision() {
  return (
    <section id="mission-vision" className="scroll-mt-36 py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="What Drives Us" title="Mission & Vision" />
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 items-stretch">
          {cards.map(({ title, icon: Icon, paragraphs }, i) => (
            <motion.article
              key={title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="flex h-full flex-col rounded-3xl border border-gray-100 border-t-4 border-t-brand-yellow bg-white p-8 sm:p-10 shadow-lg"
            >
              <div className="flex items-center gap-4">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-navy text-2xl text-brand-yellow">
                  <Icon aria-hidden="true" />
                </span>
                <h3 className="text-2xl sm:text-3xl font-bold text-brand-navy">{title}</h3>
              </div>
              {paragraphs.map((text) => (
                <p key={text.slice(0, 20)} className="mt-5 leading-relaxed text-gray-700">
                  {text}
                </p>
              ))}
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MissionVision;
